module.exports = __webpack_public_path__ + "static/icon_item2.96b6f306.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/serviceProvider/icon_item2.png
// module id = 1042
// module chunks = 2